import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import { Redirect, NavLink } from 'react-router-dom';
import ENDPOINT from '../../../globals/api-endpoint';
import styled from 'styled-components';
import Services from './services';
import Projects from './projects';
import Info from './Info';
import { Helmet  } from 'react-helmet';

const H3 = styled.h3`
	text-align: center;
	margin-top: 20px;
`;

const OptionsButton = styled.div`
	display: inline-block;
	margin : 0 auto;
`;

const Button = styled.button`
	margin: 5px;
	max-width: 250px;
	border-radius : 5px;
	padding : 5px;
	color: white;
	font-family: 'Catamaran', sans-serif;
	background: ${props => props.theme.green};
	border: 2px solid ${props => props.theme.green};
	font-size: 18px;
	transition: all 0.5s;
	&:hover {
		cursor: pointer;
		color: ${props => props.theme.green};
		background: white;
	}
`;

const Profile = () => {

	const { auth, dispatch } = useContext(AuthContext);
	const [token, setToken] = useState({
		authToken: localStorage.getItem('authToken')
	});
	const [isLoading, setIsLoading] = useState(true);
	const localToken = JSON.parse(token.authToken);
	const tokenFromStorage = localToken ? (localToken.token) : (null);

	useEffect(() => {
		setToken({
			authToken: localStorage.getItem('authToken')
		});
	}, []);

	useEffect(() => {
		const fetchData = () => { 
			setIsLoading(true);
			fetch(ENDPOINT.CHECK_AUTH, {
				headers: {
					Authorization: tokenFromStorage
				}
			})
			.then(res => res.json())
			.then(res => {
				if (res.message === 'Auth succesful') {
					dispatch({ type: 'SWITCH_AUTH', auth: true,  uid: res.userId });
				} else {
					dispatch({ type: 'SWITCH_AUTH', auth: false });
				}
			})
			.catch(err => {
				console.log(err);
			})
			.finally(res => {
				setIsLoading(false);
			});
		}
		fetchData();
	}, [dispatch, tokenFromStorage]);

	useEffect(() => {
	  window.scrollTo(0, 0)
	}, []);

	if (auth.isAuth === false) {
		return <Redirect to={'/login'} />
	}

	if (isLoading) {
		return(
			<div className="loading">
				<div className="sk-folding-cube">
				  <div className="sk-cube1 sk-cube"></div>
				  <div className="sk-cube2 sk-cube"></div>
				  <div className="sk-cube4 sk-cube"></div>
				  <div className="sk-cube3 sk-cube"></div>
				</div>
			</div>
		);
	} else {
		return(
			<div>
				<Helmet>
					<title>profil saya | bantuin</title>
				</Helmet>
				<H3>Profil</H3>
				<Info />
				<OptionsButton>
					<NavLink to={'/newproject'}>
						<Button>
							Proyek Baru
						</Button>
					</NavLink>
					<NavLink to={'/newservice'}>
						<Button>
							Layanan Baru
						</Button>
					</NavLink>
				</OptionsButton>
				<Services />
				<Projects />
			</div>
		);
	}
}

export default Profile;